// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.familyHealthSection .infoHeader {
  padding: 13px 0;
  background: #f4f7fa;
  position: relative;
  display: flex;
  -webkit-display: flex;
  position: sticky;
  position: -webkit-sticky;
  top: 118px;
  z-index: 1;
}
.familyHealthSection .infoHeader:before,
.familyHealthSection .infoHeader:after {
  content: "";
  position: absolute;
  width: 20px;
  height: 100%;
  background: #f4f7fa;
  top: 0;
}
.familyHealthSection .infoHeader:before {
  left: -20px;
}
.familyHealthSection .infoHeader:after {
  right: -20px;
}
.familyHealthSection .infoHeader__fields {
  display: inline-block;
  font-size: 12px;
  color: #505050;
  line-height: 1.5;
  font-weight: 600;
}
.familyHealthSection .infoHeader__fields--w20 {
  width: 20%;
  padding-left: 13px;
}
.familyHealthSection .infoHeader__fields--w40 {
  width: 35%;
}
.familyHealthSection .infoRow__label {
  width: 20%;
  padding: 25px 0 25px 0px;
  border-bottom: 1px solid #d6d6d6;
  margin-bottom: 0;
  position: relative;
}
.familyHealthSection .infoRow__fields {
  width: 80%;
  padding: 15px 0 15px 13px;
  border-bottom: 1px solid #d6d6d6;
  border-left: 1px solid #d6d6d6;
  position: relative;
}
.familyHealthSection .infoRow__label:after,
.familyHealthSection .infoRow__fields:after {
  position: absolute;
  content: "";
  width: 20px;
  height: 1px;
  background: #d6d6d6;
  bottom: -1px;
}
.familyHealthSection .infoRow__label:after {
  left: -20px;
}
.familyHealthSection .infoRow__fields:after {
  right: -20px;
}
.familyHealth__iconDelete {
  display: inline-block;
  margin-bottom: 20px;
}
.familyHealthSection textarea {
  margin-bottom: 0;
}
.familyHealthSection h3 {
  display: inline-block;
  margin-bottom: 0;
}
.familyHealthSection .addFieldButton {
  margin-bottom: 0;
  display: block;
}
.familyHealthSection .line-separation:after,
.familyHealthSection .line-separation:before {
  width: 15px;
}
.familyHealthSection .line-separation:after {
  right: -15px;
}
.familyHealthSection .line-separation:before {
  left: -15px;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/familyHealthHistory/FamilyHealthHistory.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,UAAU;EACV,UAAU;AACZ;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,MAAM;AACR;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,gCAAgC;EAChC,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb","sourcesContent":[".familyHealthSection .infoHeader {\n  padding: 13px 0;\n  background: #f4f7fa;\n  position: relative;\n  display: flex;\n  -webkit-display: flex;\n  position: sticky;\n  position: -webkit-sticky;\n  top: 118px;\n  z-index: 1;\n}\n.familyHealthSection .infoHeader:before,\n.familyHealthSection .infoHeader:after {\n  content: \"\";\n  position: absolute;\n  width: 20px;\n  height: 100%;\n  background: #f4f7fa;\n  top: 0;\n}\n.familyHealthSection .infoHeader:before {\n  left: -20px;\n}\n.familyHealthSection .infoHeader:after {\n  right: -20px;\n}\n.familyHealthSection .infoHeader__fields {\n  display: inline-block;\n  font-size: 12px;\n  color: #505050;\n  line-height: 1.5;\n  font-weight: 600;\n}\n.familyHealthSection .infoHeader__fields--w20 {\n  width: 20%;\n  padding-left: 13px;\n}\n.familyHealthSection .infoHeader__fields--w40 {\n  width: 35%;\n}\n.familyHealthSection .infoRow__label {\n  width: 20%;\n  padding: 25px 0 25px 0px;\n  border-bottom: 1px solid #d6d6d6;\n  margin-bottom: 0;\n  position: relative;\n}\n.familyHealthSection .infoRow__fields {\n  width: 80%;\n  padding: 15px 0 15px 13px;\n  border-bottom: 1px solid #d6d6d6;\n  border-left: 1px solid #d6d6d6;\n  position: relative;\n}\n.familyHealthSection .infoRow__label:after,\n.familyHealthSection .infoRow__fields:after {\n  position: absolute;\n  content: \"\";\n  width: 20px;\n  height: 1px;\n  background: #d6d6d6;\n  bottom: -1px;\n}\n.familyHealthSection .infoRow__label:after {\n  left: -20px;\n}\n.familyHealthSection .infoRow__fields:after {\n  right: -20px;\n}\n.familyHealth__iconDelete {\n  display: inline-block;\n  margin-bottom: 20px;\n}\n.familyHealthSection textarea {\n  margin-bottom: 0;\n}\n.familyHealthSection h3 {\n  display: inline-block;\n  margin-bottom: 0;\n}\n.familyHealthSection .addFieldButton {\n  margin-bottom: 0;\n  display: block;\n}\n.familyHealthSection .line-separation:after,\n.familyHealthSection .line-separation:before {\n  width: 15px;\n}\n.familyHealthSection .line-separation:after {\n  right: -15px;\n}\n.familyHealthSection .line-separation:before {\n  left: -15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
